document.addEventListener('DOMContentLoaded', () => {
  const initSwiper = (instance) => {
    if (!instance || instance.dataset.swiperInitialized === 'true' || typeof Swiper === 'undefined') return;

    new Swiper(instance, {
      direction: 'horizontal',
      slidesPerView: 'auto',
      spaceBetween: 14,
      loop: false,
      centeredSlides: false,
      watchOverflow: true,
      watchSlidesProgress: true,
      observer: true,
      observeParents: true,
      initialSlide: 0,
      navigation: {
        nextEl: `#next-${instance.getAttribute('id')}`,
        prevEl: `#prev-${instance.getAttribute('id')}`,
      },
    });

    instance.dataset.swiperInitialized = 'true';
  };

  const initSwipers = () => {
    document.querySelectorAll('[data-product-description-swiper]').forEach(initSwiper);
  };

  if (typeof Swiper !== 'undefined') {
    initSwipers();
    return;
  }

  const checkSwiperLoadedInterval = setInterval(() => {
    if (typeof Swiper !== 'undefined') {
      initSwipers();
      clearInterval(checkSwiperLoadedInterval);
    }
  }, 200);
});
